<template>
  <a-layout-content v-if="renderComponent">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-range-picker v-model="transactionDt" :format="getDefaultDateFormat" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="periode">Periode</label>
                  <a-monthPicker v-model="periode" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="w-full" initialValue="delivered"
                    allowClear>
                    <a-select-option value="Approved">Approved</a-select-option>
                    <a-select-option value="On Process">On Process</a-select-option>
                    <a-select-option value="Revised">Revised</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>

        <a-card class="m-top m-bottom" style="display:none">
          <!-- sementara dihidden karena menggunakan JOB  -->
          <span class="m-text-title" slot="title">Generate Default Alokasi Pekerjaan<br />[
            {{
              this.periode
              ? moment(this.periode).format("MMM YYYY").toUpperCase()
              : ""
            }}
            ]
          </span>
          <a-button block class="margin-left" icon="hourglass" type="primary" :loading="loadingGenerate" @click="handleGenerate">
            Generate
          </a-button>
        </a-card>

        <a-card class="m-top m-bottom">
          <span class="m-text-title" slot="title">Generate Rekap Alokasi Pekerjaan<br />[
            {{
              this.periode
              ? moment(this.periode).format("MMM YYYY").toUpperCase()
              : ""
            }}
            ]
          </span>
          <a-button block class="margin-left" icon="hourglass" type="primary" :loading="loadingGenerateRekap" @click="handleGenerateRekap">
            Generate
          </a-button>
        </a-card>

        <a-card class="m-top m-bottom">
          <span class="m-text-title" slot="title">TLC Belum Alokasi Pekerjaan<br />[
            {{
              this.periode
              ? moment(this.periode).format("MMM YYYY").toUpperCase()
              : ""
            }}
            ]
          </span>
          <div class="contentX m-bottom">
            <a-table bordered :rowKey="(record, index) => { return index.toString(); }" :columns="columns"
              :data-source="exportdatalist" :scroll="{ y: 250 }" :pagination="false" size="small">
              <template slot="no" slot-scope="record, item, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="email" slot-scope="record">
                <span>{{ record.email }}</span>
              </template>
            </a-table>
          </div>
          <span><i>Unduh data yang belum melaporkan alokasi pekerjaan </i></span>
          <!-- <a-button type="primary" icon="file-excel" 
            :disabled="!periode"
            @click="handleCancel">Download</a-button> -->
          <br />
          <a-tooltip placement="topLeft" title="Download Excel" arrow-point-at-center>
            <a-button class="margin-left" icon="download" type="primary" :loading="loadingExport"
              :disabled="exportdatalist.length == 0" @click="handleExport">
              Download
            </a-button>
          </a-tooltip>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist title="Monitoring Alokasi Pekerjaan" createLink="create.alokasi"
          :manifestLink="manifestFor" :dataList="basedData" :isSpecialMenu="true" :isLoading="isLoading"
          :readable="true" />
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
import _ from "lodash";

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
    "H-Datalist": DataList,
  },
  data() {
    const columns = [
      {
        title: "NO.",
        key: "no",
        width: 45,
        align: "right",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "TLC",
        key: "tlc",
        width: 55,
        align: "center",
        dataIndex: "tlc",
      },
      {
        title: "NAMA",
        key: "nama",
        dataIndex: "nama",
      },
      {
        title: "email",
        key: "email",
        class: "col_hidden",
        width: 0,
        scopedSlots: { customRender: "email" },
      },
    ];

    return {
      columns,
      transactionDt: [],
      search: "",
      dataList: [],
      basedList: [],
      specialNav: [],
      isLoading: false,
      renderComponent: true,
      periode: null,
      enableCreate: true,
      loadingExport: false,
      loadingGenerate: false,
      loadingGenerateRekap: false,
      exportdatalist: [],
      status: undefined,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    basedData() {
      let output = [];
      _.forEach(this.searching, (data) => {
        output.push({
          title: data.no_alokasi,
          subdesc: [
            this.moment(data.awal_periode).format(this.getDefaultDateFormat) +
            " - " +
            this.moment(data.akhir_periode).format(this.getDefaultDateFormat),
            data.departemen + " | " + data.posisi,
            data.site,
          ],
          id: data.id_alokasi,
          isRead: data.readorno,
          status: data.status,
        });
      });

      return output;
    },
    searching() {
      let data = this.dataList;
      if (this.search) {
        data = _.filter(
          data,
          (obj) =>
            obj.no_alokasi.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.akhir_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.awal_periode.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            (obj.departemen != null
              ? obj.departemen
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0
              : null) ||
            (obj.posisi != null
              ? obj.posisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
              : null) ||
            (obj.site != null
              ? obj.site.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
              : null)
        );
      }

      if (this.transactionDt.length > 0) {
        let startDt = moment(this.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        data = _.filter(
          data,
          (obj) => obj.awal_periode >= startDt && obj.akhir_periode <= endDt
        );
      }

      // if (this.periode) {
      //   let periode = moment(this.periode)
      //     .format("MMM YYYY")
      //     .toLowerCase();

      //   data = _.filter(
      //     data,
      //     obj => obj.periode.toLowerCase().indexOf(periode) >= 0
      //   );
      // }

      if (this.status) {
        data = _.filter(
          data,
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }
      return data;
    },
    manifestFor() {
      let manifest = "";
      if (this.spesialFor === "Direktur") {
        manifest = "dir.mon.manifest.alokasi";
      } else if (this.spesialFor === "Atasan Langsung") {
        manifest = "al.mon.manifest.alokasi";
      } else if (this.spesialFor === "HRD") {
        manifest = "hrd.mon.manifest.alokasi";
      }

      return manifest;
    },
  },
  created() {
    //this.fetching();
  },
  methods: {
    moment,
    async fetching() {
      this.isLoading = true;
      this.exportdatalist = [];
      const list = await axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/alokasi",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("mns_"),
          periode: this.periode
            ? moment(this.periode).locale("en").format("MMM YYYY").toUpperCase()
            : undefined,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .catch((err) => {
        this.dataList = []
        this.isLoading = false;
        // return err;
      });
      // const notyet = await axios({
      //   method: "get",
      //   url: this.$urlServiceNirmala + "get-karyawan-no-alokasi",
      //   params: {
      //     start_date: this.periode ? moment(this.periode).locale("en").subtract(1, 'months').format("YYYY-MM") + "-27" : undefined,
      //     end_date: this.periode ? moment(this.periode).locale("en").format("YYYY-MM") + "-28" : undefined,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // });

      Promise.all([list, //notyet
      ])
        .then(response => {
          this.dataList = response[0].data.data;
          if (response[0].data.notyet) {
            this.exportdatalist = response[0].data.notyet;
          }
          if (response[0].data.add == "1") {
            this.enableCreate = true;
            //this.enableCreate = false;
            localStorage.setItem("crtalks_", "1");
          } else {
            localStorage.setItem("crtalks_", "0");
          }
          this.isLoading = false;
        }).catch((err) => {
          this.isLoading = false;
          // return err;
        })
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
        this.fetching();
      });
    },
    handleExport(table, name) {
      this.loadingExport = true;
      setTimeout(() => {
        this.fireDownload(table, name);
        this.loadingExport = false;
      }, 2000);
    },
    fireDownload(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>table, td {border:thin solid black}table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };

      let periodExport = moment(this.periode)
        .locale("en")
        .format("MMM YYYY")
        .toUpperCase();

      if (!table.nodeType) table = document.getElementsByClassName("contentX");
      let ctx = { worksheet: name || "Worksheet", table: table[0].innerHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "Alokasi_Not_Yet periode " + periodExport + ".xls";
      a.click();
    },
    async handleGenerate(){
      if(this.periode==null){
        this.displayMessageValue("error-basic", 'Periode harus diisi!');
        return
      }
      this.loadingGenerate = true
      await axios({
        method: "post",
        url: this.$serviceUrl + "rekap_alokasi/generate_allocation_employee",
        data: {
          tlc: this.getAuth.username,
          periode: moment(this.periode).format("YYYY-MM"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.loadingGenerate = false
        this.fetching()
        this.displayMessageValue("success-basic", response.data.message);
      })
      .catch((err) => {
        this.loadingGenerate = false
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-basic", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses);
        }
      });

    },
    async handleGenerateRekap(){
      if(this.periode==null){
        this.displayMessageValue("error-basic", 'Periode harus diisi!');
        return
      }
      //if(this.exportdatalist.length>0){
      //  this.displayMessageValue("error-basic", 'Masih ada TLC yang belum alokasi pekerjaan!');
      //  return
      //}
      this.loadingGenerateRekap = true
      await axios({
        method: "post",
        url: this.$serviceUrl + "rekap_alokasi/generate_allocation_top_management",
        data: {
          tlc: this.getAuth.username,
          periode: moment(this.periode).format("YYYY-MM"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.loadingGenerateRekap = false
        this.displayMessageValue("success-basic", response.data.message);
        setTimeout(() => {
          this.$router.push({ name: "hrd.mon.ralokasi" });
        }, 1500);
      })
      .catch((err) => {
        this.loadingGenerateRekap = false
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-basic", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses);
        }
      });
    }
  },
  mounted() {
    //this.fetching();
    this.periode = moment().subtract(1, "months");
  },
  activated() {
    this.fetching();
  },
  watch: {
    periode() {
      this.fetching();
    },
  },
};
</script>

<style lang="less">
.col_hidden {
  display: none;
}
</style>
